module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.servers
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n        Empty\n      ")]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "Version"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.status))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "disabled": scope.row.status !== 'stopped'
          },
          on: {
            "click": function($event) {
              _vm.$store.dispatch('startServer', scope.row.name)
            }
          }
        }, [_vm._v("Start\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": scope.row.status !== 'started'
          },
          on: {
            "click": function($event) {
              _vm.$store.dispatch('stopServer', scope.row.name)
            }
          }
        }, [_vm._v("Stop\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.removeServer(scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'server',
                params: {
                  serverName: scope.row.name
                }
              })
            }
          }
        })]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Server"
    },
    model: {
      value: (_vm.addServerModal),
      callback: function($$v) {
        _vm.addServerModal = $$v
      },
      expression: "addServerModal"
    }
  }, [_c('el-form', {
    attrs: {
      "labelWidth": "120px"
    },
    model: {
      value: (_vm.newServerModal),
      callback: function($$v) {
        _vm.newServerModal = $$v
      },
      expression: "newServerModal"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Server Name"
    }
  }, [_c('el-input', {
    on: {
      "change": function($event) {
        _vm.sameWithServerName ? _vm.newServerModal.save = arguments[0] : ''
      }
    },
    model: {
      value: (_vm.newServerModal.name),
      callback: function($$v) {
        _vm.newServerModal.name = $$v
      },
      expression: "newServerModal.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Save Name"
    }
  }, [_c('el-select', {
    attrs: {
      "allowCreate": "",
      "filterable": "",
      "placeholder": "Please select or create"
    },
    model: {
      value: (_vm.newServerModal.save),
      callback: function($$v) {
        _vm.newServerModal.save = $$v
      },
      expression: "newServerModal.save"
    }
  }, _vm._l((_vm.saves), function(save) {
    return _c('el-option', {
      key: save.name,
      attrs: {
        "value": save.name,
        "label": save.name
      }
    })
  })), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.sameWithServerName),
      callback: function($$v) {
        _vm.sameWithServerName = $$v
      },
      expression: "sameWithServerName"
    }
  }, [_vm._v("Same with server name")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Version"
    }
  }, [_c('version-select', {
    model: {
      value: (_vm.newServerModal.version),
      callback: function($$v) {
        _vm.newServerModal.version = $$v
      },
      expression: "newServerModal.version"
    }
  })], 1), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    attrs: {
      "title": "Option"
    }
  }, [_c('server-option', {
    attrs: {
      "option": _vm.newServerModal.options
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.processing
    },
    on: {
      "click": function($event) {
        _vm.addServer()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.processing
    },
    on: {
      "click": function($event) {
        _vm.addServerModal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-187ed067"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/server/Index.vue
// module id = 156
// module chunks = 1